import React from "react";
import { useI18n } from "@/i18n";

export const CookiePolicy = () => {
  const { t } = useI18n();
  return (
    <section data-testid="cookies-page" className="bg-[#FAFAFC]">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mb-8 border-b border-slate-200 pb-6">
          <h1 className="font-serif text-3xl font-bold text-[#0F2C59] sm:text-4xl">
            {t("cookies.title")}
          </h1>
          <p className="mt-2 text-sm text-slate-500">{t("cookies.updated")}</p>
        </div>
        <article className="space-y-8">
          <div>
            <h2 className="font-serif text-xl font-semibold text-[#0F2C59]">
              {t("cookies.intro_title")}
            </h2>
            <p className="mt-3 text-base leading-relaxed text-slate-700">
              {t("cookies.intro_body")}
            </p>
          </div>
          <div>
            <h2 className="font-serif text-xl font-semibold text-[#0F2C59]">
              {t("cookies.types_title")}
            </h2>
            <div className="mt-4 space-y-4">
              <div className="rounded-sm border border-slate-200 bg-white p-5">
                <h3 className="font-serif text-lg font-semibold text-[#0F2C59]">
                  {t("cookies.types_essential_title")}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-700">
                  {t("cookies.types_essential_body")}
                </p>
              </div>
              <div className="rounded-sm border border-slate-200 bg-white p-5">
                <h3 className="font-serif text-lg font-semibold text-[#0F2C59]">
                  {t("cookies.types_analytics_title")}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-700">
                  {t("cookies.types_analytics_body")}
                </p>
              </div>
              <div className="rounded-sm border border-slate-200 bg-white p-5">
                <h3 className="font-serif text-lg font-semibold text-[#0F2C59]">
                  {t("cookies.types_marketing_title")}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-700">
                  {t("cookies.types_marketing_body")}
                </p>
              </div>
            </div>
          </div>
          <div>
            <h2 className="font-serif text-xl font-semibold text-[#0F2C59]">
              {t("cookies.manage_title")}
            </h2>
            <p className="mt-3 text-base leading-relaxed text-slate-700">
              {t("cookies.manage_body")}
            </p>
          </div>
          <div>
            <h2 className="font-serif text-xl font-semibold text-[#0F2C59]">
              {t("cookies.consent_title")}
            </h2>
            <p className="mt-3 text-base leading-relaxed text-slate-700">
              {t("cookies.consent_body")}
            </p>
          </div>
          <div>
            <h2 className="font-serif text-xl font-semibold text-[#0F2C59]">
              {t("cookies.contact_title")}
            </h2>
            <p className="mt-3 text-base leading-relaxed text-slate-700">
              {t("cookies.contact_body")}
            </p>
          </div>
        </article>
      </div>
    </section>
  );
};

export default CookiePolicy;
